export const getS3HeaderUrl = (
  filePathName: string | undefined
): string | undefined => {
  if (!filePathName) {
    return;
  }

  const isFeatureDeployment =
    (process.env.APP_STAGE ?? '').includes('lego') ||
    (process.env.APP_STAGE ?? '').includes('mvrx');

  const APP_STAGE = isFeatureDeployment ? 'int' : process.env.APP_STAGE;

  return `https://s3.${process.env.AWS_REGION}.amazonaws.com/headers-${
    APP_STAGE ?? 'int'
  }.${
    process.env.HOSTED_ZONE_NAME ?? 'st.atlasmetrics.org'
  }/${filePathName.replaceAll(' ', '+')}`;
};
